
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organize-donation-drive",
      function () {
        return require("private-next-pages/organize-donation-drive.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organize-donation-drive"])
      });
    }
  